import { AxiosResponse } from 'axios'
import { http } from '../../../../../src/utils'

export interface EwayItem {
  productName: string
  productDesc: string
  hsnCode: number
  quantity: number
  qtyUnit: string
  taxableAmount: number
  sgstRate: number
  cgstRate: number
  igstRate: number
  cessRate: number
}

export interface EwayAddress {
  address1?: string
  address2?: string
  place?: string
  pincode?: string | number
  state?: string
  stateCode?: string
}

export interface EwayBillParty {
  tradeName?: string
  gstin?: string
  address1?: string
  address2?: string
  place?: string
  pincode?: string | number
  stateCode?: string
}

export interface EwayParty {
  name: string
  gstin: string
  state: string
}

export interface EwayInfoResponse {
  challanType?: string
  documentNo?: string
  documentDate?: string
  itemList?: EwayItem[]
  vehicleNo?: string
  transporterId?: string
  transporterName?: string
  transportDocNo?: string
  dispatchFrom?: EwayAddress
  dispatchTo?: EwayAddress
  shipTo?: EwayAddress
  billFromGstin?: string
  billToGstin?: string
  billFrom?: EwayBillParty
  billTo?: EwayBillParty
}

export function getEwayInfo(challanId: number, transactionType: number) {
  return http
    .get(`/challan/pvt/${challanId}/eway_info?transaction_type=${transactionType}`)
    .then((response: AxiosResponse) => response)
}

export function getEwayItems(challanId: number) {
  const url = `/entry/pvt/eway_items?challanId=${challanId}`
  return http.get(url).then((response: AxiosResponse) => response.data)
}
